import * as React from 'react';
import { Text, View } from 'react-native';

const AdMobBanner = () => (
  <View>
    <Text>AdMobBanner component not supported on the web</Text>
  </View>
);

export default AdMobBanner;
